export const WELCOME_EMAIL_RESENT_TITLE = 'Welcome email resent';
export const WELCOME_EMAIL_RESENT_HEADER = 'We resent welcome emails to the following accounts:';
export const PASSWORD_RESET_SENT_TITLE = 'Password reset sent';
export const PASSWORD_RESET_SENT_HEADER = 'We sent password reset emails to the following accounts:';

export class UserActionDialogConfig {
  constructor(
    public actionTitle: string = '',
    public actionHeader: string = '',
    public selectedUsers: any[] = []
  ) {}
}
